import { ListToolbarConfigModel } from './config/config.model';

export class ListToolbarStateModel {
  public config: ListToolbarConfigModel = new ListToolbarConfigModel();
}
